import { useApiClient } from '~/api-client';
import { useMutation } from '@tanstack/react-query';
import { DexImageFormBootstrapView, ImageInquiry } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { DexForm } from './dex-form';
import { DexFormModel } from '../types';
import { DexQueriessubmitResource, DexQuerySubmissionImageInquiry } from '@mark43/dex-api';
import { useIsLinkToAssignedEventCheckboxVisible } from './use-is-link-to-assigned-even-visible';
import { useBuildDexQuerySubmission } from './use-build-dex-query-submission';
import { useResetValuesAfterOriAliasChange } from './use-reset-values-after-ori-alias-change';

export function DexImageForm({
    formBootstrapView,
}: {
    formBootstrapView: DexImageFormBootstrapView;
}): React.ReactElement {
    const apiClient = useApiClient();
    const isLinkToAssignedEventCheckboxVisible = useIsLinkToAssignedEventCheckboxVisible();
    const defaultValues = {
        params: formBootstrapView.defaultValues,
        requestingUnitOption: null,
        agencyEventOption: null,
        ...(isLinkToAssignedEventCheckboxVisible ? { linkToAssignedEvent: true } : null),
    };
    const form = useForm<DexFormModel<ImageInquiry>>({
        mode: 'onBlur',
        defaultValues,
    });

    useResetValuesAfterOriAliasChange({
        formInitalValues: formBootstrapView.defaultValues,
        form,
        defaultValues,
    });

    const buildDexQuerySubmission = useBuildDexQuerySubmission(
        form,
        formBootstrapView.dexFormView.dexQuery
    );
    const sendQueryMutation = useMutation((formModel: DexFormModel<ImageInquiry>) => {
        return apiClient.request<DexQueriessubmitResource.SubmitImageQuery>({
            service: 'DEX',
            method: 'POST',
            url: 'dex_queries/submit/image_inquiry',
            data: buildDexQuerySubmission(formModel) as DexQuerySubmissionImageInquiry,
        });
    });
    return (
        <DexForm
            dexFormView={formBootstrapView.dexFormView}
            defaultParams={formBootstrapView.defaultValues}
            form={form}
            sendQueryMutation={sendQueryMutation}
        />
    );
}
